import { InjectionToken } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Minimal interface for setting error page heading and message.
 * Used to avoid circular dependency between UserDataService and DashboardService.
 */
export interface IErrorMessageSetter {
  errorMessageHeading: BehaviorSubject<string>;
  errorMessage: BehaviorSubject<string>;
}

export const ERROR_MESSAGE_SETTER = new InjectionToken<IErrorMessageSetter>('ERROR_MESSAGE_SETTER');

/** Optional ADK loader for testing (avoids dynamic import in unit tests). */
export const ADK_LOADER = new InjectionToken<() => Promise<{ default?: { start: (config: any) => Promise<void> } }>>('ADK_LOADER');

/** Optional window ref for testing (avoids mutating globalThis.window). */
export const WINDOW = new InjectionToken<Window & { location?: { search?: string } }>('WINDOW');
